import React, {useEffect} from 'react';
import pictoWarning from 'images/picto_warning.svg';
import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled.div`
	display: flex;
	min-height: 55vh;
	width: 100%;
	padding: 60px 24px;
	box-sizing: border-box;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;

	h1, p {
		margin: 0;
	}

	p {
		margin-top: 16px;
	}
`;

const Error404 = () => {
	const { t } = useTranslation();
	useEffect(() => window.scrollTo(0, 0), []);

	return (
		<Container>
			<img src={pictoWarning} alt='' className='width-picto margin-bottom-20' />
			<h1 className='text-uppercase color-blue font-24 font-bold'>{t('404 — Страница не найдена')}</h1>
			<p className='color-blue font-18'>{t('Проверьте адрес или перейдите на')} <Link to='/' className='color-blue hover text-underline'>{t('главную страницу')}</Link>.</p>
		</Container>
	);
};

export default Error404;
